export const ENDPOINTS = {
  saveExperiences: '/gateway/extranet/:hotelId/experiences/inventory',
  getInventory: '/gateway/extranet/:hotelId/inventory',
  saveRooms: '/gateway/extranet/:hotelId/rooms/inventory',
  savePacks: '/gateway/extranet/:hotelId/packs/inventory',
  getPackScore: '/gateway/extranet/:hotelId/inventory/packs/scores',
  saveAutoInventory: '/gateway/extranet/:hotelId/auto-inventory',
  getAutoInventoryRooms: '/gateway/extranet/:hotelId/auto-inventory/rooms',
  getAutoInventoryInventory:
    '/gateway/extranet/:hotelId/auto-inventory/inventory',
  disableAutoInventory: '/gateway/extranet/:hotelId/auto-inventory',
  notifyChannelManagerConnection:
    '/gateway/extranet/:hotelId/auto-inventory/notify-channel-manager-connection',
  setHotelUnavailable: '/gateway/extranet/:hotelId/unavailable',
} as const;

export const CORE_QUERY_KEYS = {
  inventory: 'extranet-inventory',
  packScore: 'extranet-pack-score',
  autoInventory: 'extranet-auto-inventory',
  autoInventoryRooms: 'extranet-auto-inventory-rooms',
  autoInventoryInventory: 'extranet-auto-inventory-inventory',
} as const;
